






































import { Component, Vue } from "vue-property-decorator";
import Slick from "vue-slick";
import * as MuraflexModule from "@/assets/scripts/SliderMuraflexModule";
import $ from "jquery";

@Component({
	name: "Muraflex",
	components: { Slick }
})
export default class Muraflex extends Vue {
	data() {
		return {
			title: "Muraflex slider",
			SlickOptions: {
				dots: false,
				infinite: true,
				speed: 600,
				autoplay: true,
				autoplaySpeed: 4500,
				pauseOnHover: false,
				cssEase: "ease-in-out",
				prevArrow:
					'<li class="prev"><svg id="arrow-prev" viewBox="0 0 68.66 68.66"><title>arrow-prev</title><path d="M68.66,34.36a1.45,1.45,0,0,0-1.51-1.44H5L28.24,12.07a1.46,1.46,0,0,0,.16-2,1.39,1.39,0,0,0-2-.09L.64,33.08a1.62,1.62,0,0,0,0,2.59L26.37,58.76a1.55,1.55,0,0,0,1.93-.06,1.42,1.42,0,0,0-.06-2L5,35.83H67.15A1.49,1.49,0,0,0,68.66,34.36Z"></path></svg></li>',
				nextArrow:
					'<li class="next"><svg id="arrow-prev" viewBox="0 0 68.66 68.66"><title>arrow-prev</title><path d="M68.66,34.36a1.45,1.45,0,0,0-1.51-1.44H5L28.24,12.07a1.46,1.46,0,0,0,.16-2,1.39,1.39,0,0,0-2-.09L.64,33.08a1.62,1.62,0,0,0,0,2.59L26.37,58.76a1.55,1.55,0,0,0,1.93-.06,1.42,1.42,0,0,0-.06-2L5,35.83H67.15A1.49,1.49,0,0,0,68.66,34.36Z"></path></svg></li>',
				responsive: [
					// You can unslick at a given breakpoint now by adding:
					// settings: "unslick"
					// instead of a settings object
				]
			},
			slides: [
				{
					title: "Expo",
					titleSub: "Cras posuere placerat felis",
					imgSrc: "/assets/images/SliderCutImg3.jpg",
					buttonText: "Call to action"
				},
				{
					title: "Aliqu",
					titleSub: "Phasellus cursus nulla",
					imgSrc: "/assets/images/SliderCutImg3.jpg",
					buttonText: "Call to action"
				},
				{
					title: "Donec",
					titleSub: "Quisque id semper turpis",
					imgSrc: "/assets/images/SliderCutImg3.jpg",
					buttonText: "Call to action"
				},
				{
					title: "Domin",
					titleSub: "Quisquasd sd turpis",
					imgSrc: "/assets/images/SliderCutImg3.jpg",
					buttonText: "Call to action"
				}
			]
		};
	}

	runEvent(event, slick) {
		new MuraflexModule.MuraflexModule(event, slick, event.type, null, null);
	}
	beforeChange(event, slick, currentSlide, nextSlide) {
		new MuraflexModule.MuraflexModule(
			event,
			slick,
			event.type,
			currentSlide,
			nextSlide
		);
	}
}
